import { Browser } from "../utils/Browser";
export var StatElement;
(function (StatElement) {
    StatElement[StatElement["CT_FPS"] = 0] = "CT_FPS";
    StatElement[StatElement["T_Frame_Time"] = 1] = "T_Frame_Time";
    StatElement[StatElement["T_AllRender3D"] = 2] = "T_AllRender3D";
    StatElement[StatElement["T_DepthPass"] = 3] = "T_DepthPass";
    StatElement[StatElement["T_ShadowPass"] = 4] = "T_ShadowPass";
    StatElement[StatElement["T_3DMainPass"] = 5] = "T_3DMainPass";
    StatElement[StatElement["T_3DMainPass_Opaque"] = 6] = "T_3DMainPass_Opaque";
    StatElement[StatElement["T_3DMainPass_Trans"] = 7] = "T_3DMainPass_Trans";
    StatElement[StatElement["T_3DBatchTime"] = 8] = "T_3DBatchTime";
    StatElement[StatElement["T_CullMain"] = 9] = "T_CullMain";
    StatElement[StatElement["T_CullShadow"] = 10] = "T_CullShadow";
    StatElement[StatElement["T_Render_PostProcess"] = 11] = "T_Render_PostProcess";
    StatElement[StatElement["T_AllRender2D"] = 12] = "T_AllRender2D";
    StatElement[StatElement["T_2DPass"] = 13] = "T_2DPass";
    StatElement[StatElement["T_ScriptUpdateTime"] = 14] = "T_ScriptUpdateTime";
    StatElement[StatElement["T_ScriptLateUpdateTime"] = 15] = "T_ScriptLateUpdateTime";
    StatElement[StatElement["CT_OpaqueDrawCall"] = 16] = "CT_OpaqueDrawCall";
    StatElement[StatElement["CT_TransDrawCall"] = 17] = "CT_TransDrawCall";
    StatElement[StatElement["CT_DepthCastDrawCall"] = 18] = "CT_DepthCastDrawCall";
    StatElement[StatElement["CT_ShadowDrawCall"] = 19] = "CT_ShadowDrawCall";
    StatElement[StatElement["CT_2DDrawCall"] = 20] = "CT_2DDrawCall";
    StatElement[StatElement["CT_3DDrawCall"] = 21] = "CT_3DDrawCall";
    StatElement[StatElement["CT_DrawCall"] = 22] = "CT_DrawCall";
    StatElement[StatElement["CT_IndirectDrawCall"] = 23] = "CT_IndirectDrawCall";
    StatElement[StatElement["CT_Instancing_DrawCall"] = 24] = "CT_Instancing_DrawCall";
    StatElement[StatElement["M_GPUBuffer"] = 25] = "M_GPUBuffer";
    StatElement[StatElement["C_GPUBuffer"] = 26] = "C_GPUBuffer";
    StatElement[StatElement["M_VertexBuffer"] = 27] = "M_VertexBuffer";
    StatElement[StatElement["C_VertexBuffer"] = 28] = "C_VertexBuffer";
    StatElement[StatElement["M_IndexBuffer"] = 29] = "M_IndexBuffer";
    StatElement[StatElement["C_IndexBuffer"] = 30] = "C_IndexBuffer";
    StatElement[StatElement["M_UBOBuffer"] = 31] = "M_UBOBuffer";
    StatElement[StatElement["C_UBOBuffer"] = 32] = "C_UBOBuffer";
    StatElement[StatElement["M_DeviceBuffer"] = 33] = "M_DeviceBuffer";
    StatElement[StatElement["C_DeviceBuffer"] = 34] = "C_DeviceBuffer";
    StatElement[StatElement["M_AllTexture"] = 35] = "M_AllTexture";
    StatElement[StatElement["C_AllTexture"] = 36] = "C_AllTexture";
    StatElement[StatElement["M_Texture2D"] = 37] = "M_Texture2D";
    StatElement[StatElement["C_Texture2D"] = 38] = "C_Texture2D";
    StatElement[StatElement["M_TextureCube"] = 39] = "M_TextureCube";
    StatElement[StatElement["C_TextureCube"] = 40] = "C_TextureCube";
    StatElement[StatElement["M_Texture3D"] = 41] = "M_Texture3D";
    StatElement[StatElement["C_Texture3D"] = 42] = "C_Texture3D";
    StatElement[StatElement["M_Texture2DArray"] = 43] = "M_Texture2DArray";
    StatElement[StatElement["C_Texture2DArray"] = 44] = "C_Texture2DArray";
    StatElement[StatElement["M_RenderTexture"] = 45] = "M_RenderTexture";
    StatElement[StatElement["C_RenderTexture"] = 46] = "C_RenderTexture";
    StatElement[StatElement["M_GPUMemory"] = 47] = "M_GPUMemory";
    StatElement[StatElement["CT_ShaderChange"] = 48] = "CT_ShaderChange";
    StatElement[StatElement["CT_Triangle"] = 49] = "CT_Triangle";
    StatElement[StatElement["CT_BufferUploadCount"] = 50] = "CT_BufferUploadCount";
    StatElement[StatElement["CT_GeometryBufferUploadCount"] = 51] = "CT_GeometryBufferUploadCount";
    StatElement[StatElement["CT_UBOBufferUploadCount"] = 52] = "CT_UBOBufferUploadCount";
    StatElement[StatElement["CT_UBOBufferUploadMemory"] = 53] = "CT_UBOBufferUploadMemory";
    StatElement[StatElement["C_Sprite2DCount"] = 54] = "C_Sprite2DCount";
    StatElement[StatElement["C_Sprite3DCount"] = 55] = "C_Sprite3DCount";
    StatElement[StatElement["C_BaseRenderCount"] = 56] = "C_BaseRenderCount";
    StatElement[StatElement["C_MeshRenderCount"] = 57] = "C_MeshRenderCount";
    StatElement[StatElement["C_SkinnedMeshRenderCount"] = 58] = "C_SkinnedMeshRenderCount";
    StatElement[StatElement["C_ShurikenParticleRenderCount"] = 59] = "C_ShurikenParticleRenderCount";
    StatElement[StatElement["T_AnimatorUpdate"] = 60] = "T_AnimatorUpdate";
    StatElement[StatElement["T_SkinBoneUpdate"] = 61] = "T_SkinBoneUpdate";
    StatElement[StatElement["T_ShurikenUpdate"] = 62] = "T_ShurikenUpdate";
    StatElement[StatElement["T_Physics_Simulation"] = 63] = "T_Physics_Simulation";
    StatElement[StatElement["T_Physics_UpdateNode"] = 64] = "T_Physics_UpdateNode";
    StatElement[StatElement["T_PhysicsEvent"] = 65] = "T_PhysicsEvent";
    StatElement[StatElement["C_PhysicsEventCount"] = 66] = "C_PhysicsEventCount";
    StatElement[StatElement["T_PhysicsCollider"] = 67] = "T_PhysicsCollider";
    StatElement[StatElement["T_PhysicsTrigger"] = 68] = "T_PhysicsTrigger";
    StatElement[StatElement["T_PhysicsColliderEnter"] = 69] = "T_PhysicsColliderEnter";
    StatElement[StatElement["T_PhysicsColliderExit"] = 70] = "T_PhysicsColliderExit";
    StatElement[StatElement["T_PhysicsColliderStay"] = 71] = "T_PhysicsColliderStay";
    StatElement[StatElement["T_PhysicsTriggerEnter"] = 72] = "T_PhysicsTriggerEnter";
    StatElement[StatElement["T_PhysicsTriggerExit"] = 73] = "T_PhysicsTriggerExit";
    StatElement[StatElement["T_PhysicsTriggerStay"] = 74] = "T_PhysicsTriggerStay";
    StatElement[StatElement["C_PhysicaDynamicRigidBody"] = 75] = "C_PhysicaDynamicRigidBody";
    StatElement[StatElement["C_PhysicaStaticRigidBody"] = 76] = "C_PhysicaStaticRigidBody";
    StatElement[StatElement["C_PhysicaKinematicRigidBody"] = 77] = "C_PhysicaKinematicRigidBody";
    StatElement[StatElement["C_PhysicaCharacterController"] = 78] = "C_PhysicaCharacterController";
    StatElement[StatElement["C_PhysicsJoint"] = 79] = "C_PhysicsJoint";
    StatElement[StatElement["T_LoadResourceTime"] = 80] = "T_LoadResourceTime";
    StatElement[StatElement["C_LoadResourceCount"] = 81] = "C_LoadResourceCount";
    StatElement[StatElement["C_LoadRequestCount"] = 82] = "C_LoadRequestCount";
    StatElement[StatElement["T_LoadRequestTime"] = 83] = "T_LoadRequestTime";
    StatElement[StatElement["StatEnd"] = 84] = "StatEnd";
})(StatElement || (StatElement = {}));
export class DefaultStaticsContext {
    constructor() {
        this._tQueue = new Set();
        this._ctQueue = new Set();
        this._cacheCount = 0;
        this._cacheTime = 0;
        this._cacheTime = Browser.now();
        this._createStatBuffer();
        for (let i = 0; i < StatElement.StatEnd; i++) {
            const elementName = StatElement[i];
            if (!elementName)
                continue;
            if (elementName.startsWith("T_")) {
                this._tQueue.add(i);
            }
            if (elementName.startsWith("CT_"))
                this._ctQueue.add(i);
        }
    }
    _createStatBuffer() {
        this._statArray = new Float32Array(StatElement.StatEnd);
        this._timeArray = new Float32Array(StatElement.StatEnd);
    }
    cloneTo(context) {
        for (let i = 0; i < StatElement.StatEnd; i++) {
            const elementName = StatElement[i];
            if (!elementName)
                continue;
            if (elementName.startsWith("C_")) {
                (context).recordCountData(i, this._statArray[i]);
            }
            else if (elementName.startsWith("M_")) {
                (context).recordMemoryData(i, this._statArray[i] * 1024 * 1024);
            }
        }
    }
    recordCountData(element, data) {
        this._statArray[element] += data;
    }
    recordTimeData(element, data) {
        this._timeArray[element] += data;
    }
    recordCTData(element, data) {
        this._timeArray[element] += data;
    }
    recordMemoryData(element, data) {
        this._statArray[element] += data / 1024 / 1024;
    }
    getElementData(element) {
        return this._statArray[element];
    }
    startFrameLogic() {
    }
    endFrameLogic() {
        this._cacheCount++;
        let time = Browser.now();
        let deltytime = time - this._cacheTime;
        if (deltytime < 1000)
            return;
        let fps = Math.round(this._cacheCount * 1000) / (time - this._cacheTime);
        for (let element of this._tQueue) {
            this._statArray[element] = this._timeArray[element] / this._cacheCount / 1000;
            this._timeArray[element] = 0;
        }
        for (let element of this._ctQueue) {
            this._statArray[element] = this._timeArray[element] / this._cacheCount;
            this._timeArray[element] = 0;
        }
        this._statArray[StatElement.CT_FPS] = Math.round(fps);
        this._statArray[StatElement.T_Frame_Time] = fps > 0 ? Math.floor(1000 / fps) : 0;
        this._cacheTime = time;
        this._cacheCount = 0;
    }
}
